import React from "react";
import Nav from "@/components/store/Nav";
import CartDrawer from "@/components/store/CartDrawer";
import PlatePreviewer from "@/components/store/PlatePreviewer";
import {
  Hero,
  ChaptersSection,
  CatalogSection,
  MaterialsSection,
  ReviewsSection,
  FaqSection,
  CheckoutSection,
  Footer,
} from "@/components/store/Sections";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-neutral-950 text-neutral-100 min-h-screen antialiased">
      <Nav />
      <Hero />
      <ChaptersSection />
      <CatalogSection />
      <MaterialsSection />
      <PlatePreviewer />
      <ReviewsSection />
      <FaqSection />
      <CheckoutSection />
      <Footer />
      <CartDrawer />
    </div>
  );
}
